import * as React from "react";
import { observer } from "mobx-react";
import { match } from "react-router-dom";
import { Grid, withStyles } from "@material-ui/core";
import SplitterLayout from "react-splitter-layout";
import SearchHeader from "modules/composition/components/layouts/SearchHeader";
import SideMenu from "modules/composition/components/layouts/SideMenu";
import GroupContent from "modules/composition/components/layouts/GroupContent";
import TaskContent from "modules/composition/components/layouts/TaskContent";
import { CompositionStore } from "modules/composition/CompositionStore";
import ResourceContent from "modules/composition/components/layouts/ResourceContent";
import SubscribeNowCard from "modules/development/components/layouts/SubscribeNowCard";

const styles = (theme) => ({
  grid: {
    "& > .splitter-layout": {
      height: "calc(100% - 128px)",
    },
  },
});

interface Params {
  id: string;
}

type IProps = {
  classes: any;
  match: match<Params>;
};

@observer
class Composition extends React.Component<IProps> {
  state = {
    loaded: false,
    reload: false,
  };

  componentDidMount() {
    this.getBenchCompositionFile();
  }

  componentWillUnmount() {
    CompositionStore.resetStore();
  }

  getBenchCompositionFile = async () => {
    await CompositionStore.getBenchCompositionFile(this.props.match.params.id);
    this.setState({ loaded: true });
  };

  // Função criada para fazer o componente renderizar novamente do component
  _reloadComponent = () => {
    this.setState({ reload: true });
    CompositionStore.loading = true;
    this.setState({ reload: false });
  };

  render() {
    const { loaded, reload } = this.state,
      { classes } = this.props,
      { group, rateTask, resource } = CompositionStore;
    let datas = location.pathname.split("/");
    let inUrl = datas[datas.length - 1],
      idResource = inUrl == "resources" ? true : false;
    let groupV = group,
      rateTaskV = rateTask;

    if (idResource) {
      groupV = false;
      rateTaskV = false;
    }

    return (
      loaded &&
      !reload && (
        <Grid container>
          <SubscribeNowCard />
          <Grid item xs={12}>
            <SearchHeader />
          </Grid>
          <Grid item xs={12} className={classes.grid}>
            <SplitterLayout
              horizontal
              percentage
              secondaryInitialSize={80}
              onDragEnd={() => CompositionStore.setTooltipStyle()}
            >
              <SideMenu />
              <div>
                {idResource ? (
                  <ResourceContent _reloadComponent={this._reloadComponent} /> // Passando a função pra o componente
                ) : null}
                {groupV && <GroupContent />}
                {rateTaskV && rateTaskV.data ? (
                  <TaskContent _reloadComponent={this._reloadComponent} /> // Passando a função pra o componente
                ) : null}
              </div>
            </SplitterLayout>
          </Grid>
        </Grid>
      )
    );
  }
}

export default withStyles(styles)(Composition);



// WEBPACK FOOTER //
// ./src/modules/composition/components/pages/Composition.tsx